import { render } from "./AgentRequest.vue?vue&type=template&id=6c38efc2&scoped=true"
import script from "./AgentRequest.vue?vue&type=script&lang=js"
export * from "./AgentRequest.vue?vue&type=script&lang=js"

import "./AgentRequest.vue?vue&type=style&index=0&id=6c38efc2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c38efc2"]])

export default __exports__